import { render } from "./automatizar-add.vue?vue&type=template&id=a2b358f8"
import script from "./automatizar-add.vue?vue&type=script&lang=js"
export * from "./automatizar-add.vue?vue&type=script&lang=js"

import "./automatizar-add.vue?vue&type=style&index=0&id=a2b358f8&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__